<template>
  <div>
    <div class="layer-wrapper" :key="element.id" v-for="element in filteredElements">
      <layer
        :selected="selected"
        :graphic_field="graphic_fields[element.id]"
        :element="element"
        :force-expanded="!!normalizedFilter"
        :data-test="`graphics-editor-layer-${element.id}`"
        @select="select"
        @add-slide="addSlide"
        @toggleVisible="toggleVisible(element)"
      />

      <layers
        v-if="isGroup(element) && (!element.collapsed || normalizedFilter)"
        class="sub-layers"
        :selected="selected"
        :graphic_fields="graphic_fields"
        :sub_elements="element.elements"
        :filter="normalizedFilter"
        :data-test="`graphics-editor-layer-${element.id}`"
        @select="select"
        @change="$emit('change')"
        @toggleVisible="$emit('toggleVisible', $event)"
      />

      <slide-layers
        v-if="element.type === 'slideshow' && (!element.collapsed || normalizedFilter)"
        :selected="selected"
        :element="element"
        :graphic_fields="graphic_fields"
        :filter="normalizedFilter"
        :data-test="`graphics-editor-layer-${element.id}`"
        @select="select"
      />
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { entriesMap, isLayerGroup, matchesLayerTitle } from '../../../utils/graphics-utils';
import LayerComponent from './Layer.vue';

export default {
  name: 'layers',
  props: ['selected', 'graphic_fields', 'modelValue', 'value', 'sub_elements', 'filter'],
  data() {
    return {
      selectedSlide: null,
    };
  },
  components: {
    layer: LayerComponent,
    SlideLayers: defineAsyncComponent(() => import('../slide-layers/SlideLayers.vue')),
  },
  computed: {
    elements() {
      // Am I a single graphic layer or am I a parent?
      return this.modelValue ?? this.value ?? this.sub_elements;
    },
    normalizedFilter() {
      return this.filter?.trim().toLowerCase() || '';
    },
    filteredElements() {
      const query = this.normalizedFilter;
      if (!query) return this.elements;

      return this.elements.filter(
        (element) => matchesLayerTitle(element, query, this.graphic_fields),
      );
    },
  },
  methods: {
    isGroup: isLayerGroup,

    toggleVisible(element) {
      if (!this.graphic_fields[element.id]) {
        this.graphic_fields[element.id] = { visible: true };
      }

      const { visible } = this.graphic_fields[element.id];
      this.graphic_fields[element.id].visible = !visible;
      this.$emit('change');
    },

    select(element) {
      if (element.type !== 'group') {
        this.$emit('select', element);
      }
    },

    addSlide(element) {
      if (!this.graphic_fields[element.id]?.entries) {
        this.$set(this.graphic_fields[element.id], 'entries', []);
      }

      // eslint-disable-next-line vue/no-mutating-props
      const { entries } = this.graphic_fields[element.id];

      this.$set(this.graphic_fields[element.id], 'entries', [
        ...entries,
        {
          fields: entriesMap(element.elements, this.graphic_fields),
          meta: {
            name: `Slide ${(+this.graphic_fields[element.id].entries.length + 1).toString()}`,
            collapsed: false,
            visible: true,
          },
        },
      ]);

      // Shorten any QR codes for new slide by triggering a full generate for now
      this.$store.dispatch('generateShortUrls');
      this.$emit('change');
    },
  },
};
</script>
